// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import 'zone.js/dist/zone-error';

export const environment = {
  production: false,
  apiUrl: 'https://api.dev.pia.publicare-gmbh.de',
  templateBuilderUrl: 'https://tb.dev.pia.publicare-gmbh.de',
  // local test
  // apiUrl: 'http://localhost:3000',
  // templateBuilderUrl: 'http://localhost:12000',
  auth: {
    clientId: '14165ce6-5d71-4c2b-8753-582f3df45241',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
